import { P2GAlert, P2GBox, P2GText } from '@parcel2go/core-ui';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { GetPrePayBalanceResponse } from '~/lib/api/me/types';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

type PrePayBalanceDisplayProps = {
  balance: GetPrePayBalanceResponse;
  includePromotion?: boolean;
};

const PrePayBalanceDisplay = ({ balance, includePromotion }: PrePayBalanceDisplayProps) => {
  const { t } = useTranslation(TranslationNamespaces.PREPAY);

  if (!balance) {
    return null;
  }

  return (
    <P2GAlert>
      <P2GText>
        <Trans
          i18nKey="BALANCE"
          t={t}
          values={{ balance: toDisplayCurrency(balance.currencyCode, balance.balance) }}
          components={{ b: <strong /> }}
          defaults="Your current PrePay balance is <b>{{balance}}</b>."
        />
      </P2GText>
      {includePromotion && balance.freePrePayPercentage > 0 && (
        <P2GBox mt={1}>
          <P2GText component="div">
            <Trans
              i18nKey="EXTRA_CREDIT"
              t={t}
              values={{
                amount: toDisplayCurrency(balance.currencyCode, balance.freePrePayMinimumSpend, 0),
                percentage: balance.freePrePayPercentage
              }}
              components={{ b: <strong /> }}
              defaults="Add <b>{{amount}}</b> PrePay to your account and we will give you an extra <b>{{percentage}}%</b> for FREE."
            />
          </P2GText>
        </P2GBox>
      )}
    </P2GAlert>
  );
};

export default PrePayBalanceDisplay;
